export const IMAGE_PROCESSING_STATUS_ID = '1'
export const IMAGE_SUCCESS_STATUS_ID = '2'
export const IMAGE_FAILED_STATUS_ID = '3'